import { required } from "@vuelidate/validators";
import { reactive, computed } from "vue";

const validations = computed(() => {
  return {
    firstname: { required },
    lastname: { required },
    phone: { required },
    available: { required },
  };
});

const state = reactive({
  firstname: "",
  lastname: "",
  phone: "",
  available: null,
});

export { validations, state };
